<template>
    <div>
        <h1>This is a Tools Page</h1>
        <p><strong>A collection of tools commonly used in mathematics, chemistry, and physics. </strong></p>
        <div class="parent-container">
            <div class="border-container">
                <div class="info-container">
                    <h3>Desmos: <a href="https://www.desmos.com/calculator">Visit the Website</a></h3>
                    <vs-button @click="desmosActive=true" color="primary" type="filled" v-if="!isMobile">
                        Preview
                    </vs-button>
                    <vs-popup :active.sync="desmosActive" fullscreen title="Desmos Graphing" v-if="!isMobile">
                        <div style="overflow:hidden;">
                            <iframe height="1000px" src="https://www.desmos.com/calculator"
                                    width="100%"></iframe>
                        </div>
                    </vs-popup>
                    <br>
                    <p style="margin-bottom: 5px"><strong>Explore math with Desmos.</strong>
                        Graph functions, plot data, evaluate equations, explore transformations, and much more – for
                        free!</p>
                </div>
            </div>
        </div>
        <br>
        <div class="parent-container">
            <div class="border-container">
                <div class="info-container">
                    <h3>Dynamic Periodic Table: <a href="https://ptable.com/">Visit the Website</a></h3>
                    <vs-button @click="pTableActive=true" color="primary" type="filled" v-if="!isMobile">
                        Preview
                    </vs-button>
                    <vs-popup :active.sync="pTableActive" fullscreen title="Dynamic Periodic Table" v-if="!isMobile">
                        <div style="overflow:hidden;">
                            <iframe height="1000px" src="https://ptable.com/"
                                    width="100%"></iframe>
                        </div>
                    </vs-popup>
                    <br>
                    <p><strong>The world's most popular periodic table web site!</strong> Dynamic layouts, property
                        trend visualization, orbitals, thousands of isotopes, and 5 writeup sources.</p>
                </div>
            </div>
        </div>
        <br>
        <div class="parent-container">
            <div class="border-container">
                <div class="info-container">
                    <h3>Symbolab: <a href="https://www.symbolab.com/">Visit the Website</a></h3>
                    <vs-button color="primary" disabled type="filled" v-if="!isMobile">
                        No Preview Available
                    </vs-button>
                    <br>
                    <p><strong>Symbolab: equation search and math solver</strong> - solves algebra, trigonometry and
                        calculus problems step by step.</p>
                </div>
            </div>
        </div>
        <br>
        <div class="parent-container">
            <div class="border-container">
                <div class="info-container">
                    <h3>UnitConverters.net: <a href="https://www.unitconverters.net/">Visit the Website</a></h3>
                    <vs-button @click="unitConverterActive=true" color="primary" type="filled" v-if="!isMobile">
                        Preview
                    </vs-button>
                    <vs-popup :active.sync="unitConverterActive" fullscreen title="Unit Converter" v-if="!isMobile">
                        <div style="overflow:hidden;">
                            <iframe height="1000px" src="https://www.unitconverters.net/"
                                    width="100%"></iframe>
                        </div>
                    </vs-popup>
                    <br>
                    <p>
                        <strong>Quick, free, online unit converter that converts common units of measurement</strong>,
                        along with 77
                        other converters covering an assortment of units.</p>
                </div>
            </div>
        </div>
        <br>
        <div class="parent-container">
            <div class="border-container">
                <div class="info-container">
                    <h3>WolframAlpha: <a href="https://www.wolframalpha.com/">Visit the Website</a></h3>
                    <vs-button @click="wolframAlphaActive=true" color="primary" type="filled" v-if="!isMobile">
                        Preview
                    </vs-button>
                    <vs-popup :active.sync="wolframAlphaActive" fullscreen title="WolframAlpha" v-if="!isMobile">
                        <div style="overflow:hidden;">
                            <iframe height="1000px" src="https://www.wolframalpha.com/"
                                    width="100%"></iframe>
                        </div>
                    </vs-popup>
                    <br>
                    <p><strong>Compute answers using Wolfram's breakthrough technology & knowledgebase</strong>, relied
                        on by millions of students & professionals.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                unitConverterActive: false,
                wolframAlphaActive: false,
                desmosActive: false,
                pTableActive: false,
                isMobile: this.mobileCheck()
            }
        },
        methods: {
            mobileCheck: function () {
                let check = false;
                (function (a) {
                    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw(n|u)|c55\/|capi|ccwa|cdm|cell|chtm|cldc|cmd|co(mp|nd)|craw|da(it|ll|ng)|dbte|dcs|devi|dica|dmob|do(c|p)o|ds(12|d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(|_)|g1 u|g560|gene|gf5|gmo|go(\.w|od)|gr(ad|un)|haie|hcit|hd(m|p|t)|hei|hi(pt|ta)|hp( i|ip)|hsc|ht(c(| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i(20|go|ma)|i230|iac( ||\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|[a-w])|libw|lynx|m1w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|mcr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|([1-8]|c))|phil|pire|pl(ay|uc)|pn2|po(ck|rt|se)|prox|psio|ptg|qaa|qc(07|12|21|32|60|[2-7]|i)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h|oo|p)|sdk\/|se(c(|0|1)|47|mc|nd|ri)|sgh|shar|sie(|m)|sk0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h|v|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl|tdg|tel(i|m)|tim|tmo|to(pl|sh)|ts(70|m|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
                })(navigator.userAgent || navigator.vendor || window.opera);
                console.log(check)
                return check;
            }
        }
    }
</script>
<style scoped>
    .parent-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .info-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 80%;
        max-width: 80%;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .border-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 80%;
        max-width: 80%;
        background: rgba(255, 255, 255, 0.6);
        border-width: 2px;
        border-color: blue;
        border-radius: 10px;
    }
</style>